import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0c44af28"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "accordionButton",
  key: "up"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { type: "button" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-caret-up" })
], -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  class: "accordionButton",
  key: "down"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { type: "button" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-caret-down" })
], -1))
const _hoisted_6 = [
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: _normalizeClass(["accordion", _ctx.openThis ? 'open' : ''])
    }, [
      _createElementVNode("div", {
        class: "accordionTitle",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openThis = !_ctx.openThis))
      }, [
        _renderSlot(_ctx.$slots, "title", {}, undefined, true),
        (_ctx.openThis)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
          : _createCommentVNode("", true),
        (!_ctx.openThis)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
          : _createCommentVNode("", true)
      ]),
      (_ctx.openThis)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["accordionBody", {'indent': _ctx.indent}])
          }, [
            _renderSlot(_ctx.$slots, "default", {}, undefined, true)
          ], 2))
        : _createCommentVNode("", true)
    ], 2)
  ]))
}